import { get } from 'lodash-es';

import { LogService } from './log-service';

const deriveTotalPrice = (labelCost, insuranceCost) => {
  if (labelCost.code !== insuranceCost?.code) {
    LogService.logInfo('Deriving total price with potentially two different or unknown currencies', { labelCost, insuranceCost });
  }
  // This makes the (temporarily correct) incorrect assumption that insurance and label will always be the same currency
  return {
    code: labelCost.code,
    value: labelCost.value + insuranceCost.value,
  };
};

class ShipmentHelperServiceClass {
  anyNotificationErrored(shipmentStatus) {
    return !!Object.keys(shipmentStatus)
      .filter((key) => key.includes('Notification'))
      .map((notificationType) => get(shipmentStatus, `${notificationType}.errorMessage`, null))
      .filter((error) => error !== null).length;
  }

  getTotalCost(fulfillment = {}, rateSummaryTotalCost) {
    const { totalCost, labelCost, insuranceCost, insuranceProviderId } = fulfillment;
    const hasNonZeroInsuranceCostValue = insuranceCost && insuranceCost.value;
    const hasNonZeroLabelCostValue = labelCost && labelCost.value;

    // Once the backend begins providing totalCost as part of the fulfillment object, this function will use that value instead of hacking together our own. At this point we should determine whether any of the code in this file is necesssary
    if (totalCost) {
      LogService.logInfo('Using total cost from fulfillment plan... remove code to rely on deriving it', {
        totalCost,
        labelCost,
        insuranceCost,
      });
      return totalCost;
    }

    if (!hasNonZeroInsuranceCostValue) {
      return labelCost;
    }

    // Here we will add insurance and label cost and compare to the FP Rate Summary cost for confirmation.
    if (hasNonZeroLabelCostValue) {
      const derivedTotalCost = deriveTotalPrice(labelCost, insuranceCost);
      if (
        fulfillment.fulfillmentId &&
        rateSummaryTotalCost &&
        (derivedTotalCost.code !== rateSummaryTotalCost?.code || derivedTotalCost.value !== rateSummaryTotalCost?.value)
      ) {
        LogService.logInfo('Fulfillment Calculated Total Cost (label + insurance) different from FulfillmentPlan Rate Summary Total Cost', {
          derivedTotalCost,
          rateSummaryTotalCost,
          insuranceProviderId,
        });
      }
      return derivedTotalCost;
    }
  }
}

export const ShipmentHelperService = new ShipmentHelperServiceClass();
